import {
  Checkbox,
  CheckboxProps,
  Link,
  mergeOverrides,
  ParagraphMedium,
} from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET, routes } from "#/shared/constants"

type TermsOfUseCheckboxProps = Omit<CheckboxProps, "children">

export default function TermsOfUseCheckbox({
  overrides,
  ...props
}: TermsOfUseCheckboxProps) {
  return (
    <Checkbox
      overrides={mergeOverrides(
        {
          Root: {
            style: {
              textAlign: "left",
              alignItems: "center",
            },
          },
        },
        overrides,
      )}
      {...props}
    >
      <ParagraphMedium>
        {`I understand this ${
          IS_MEZO_MAINNET ? "is" : "isn't"
        } real money and I accept`}{" "}
        <Link
          href={routes.TERMS}
          $style={{ textWrap: "nowrap" }}
          target="_blank"
        >
          Mezo&apos;s Terms of Use
        </Link>
      </ParagraphMedium>
    </Checkbox>
  )
}
